import uploader from 'services/file-upload';
import Encoder, { JobStatus } from 'services/encoder';
import {
  getAudioMarker,
  getAudioMarkerUrl,
  hasAudioMarkerWithMedia,
} from '../../../shared/helpers/markers';
import isValidUrl from '../../../shared/helpers/is-valid-url';

const EMPTY_DESCRIPTION_PERMUTATIONS = [
  '',
  '<p></p>',
  '<p><br></p>',
  '<div></div>',
  '<div><br></div>',
  '<div><p></p></div>',
];

function getNameError(episode) {
  if (!episode.name || episode.name === 'Untitled Episode') {
    return 'Episode needs a name.';
  }
  return null;
}

function getDescriptionError(episode) {
  if (!episode.description || EMPTY_DESCRIPTION_PERMUTATIONS.includes(episode.description)) {
    return 'Episode needs a description.';
  }
  return null;
}

function getUploadingError(episode, markers) {
  const audioMarker = getAudioMarker(markers);

  if (!audioMarker) {
    return null;
  }

  const upload = uploader.get(audioMarker.id, 'media');

  if (upload) {
    const percent = Math.floor(upload.progress * 100);
    return `Audio is being uploaded: ${percent}%`;
  }
  if (!hasAudioMarkerWithMedia(markers)) {
    return 'Episode has no audio file.';
  }
  if (!episode.mediaURL) {
    return 'Episode has no audio file. Please try re-uploading the audio file.';
  }
  return null;
}

function getEncodingError(markers) {
  const audioMarker = getAudioMarker(markers);
  const mediaUrl = getAudioMarkerUrl(markers);

  if (!audioMarker) {
    return null;
  }

  const encoding = Encoder.getJobForMediaUrl(mediaUrl);

  if (!encoding) {
    return null;
  }
  const { status } = encoding;

  if (status === JobStatus.Failed) {
    return 'Episode audio encoding failed.';
  }

  if (status !== JobStatus.Completed && status !== JobStatus.CompletedWithoutUpdate) {
    return 'Episode audio is being encoded.';
  }

  return null;
}

function getRssLinkError(episode) {
  const { rssLink } = episode;

  if (!rssLink || isValidUrl(rssLink)) {
    return null;
  }

  return 'RSS link should be a valid URL or an empty string.';
}

export default function validateBasicInfo(episode, markers) {
  return [
    getNameError(episode),
    getDescriptionError(episode),
    getUploadingError(episode, markers),
    getEncodingError(markers),
    getRssLinkError(episode),
  ].filter(error => !!error);
}
